import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { AHCREvent } from '../types/ahcr-event.types'
import { getColorInfo, getGenderInfo } from '../utils/ahcr-event-formatters'
import { formatStayDuration, isLoitering } from '../utils/format-stay-duration'

interface AHCREventGridItemProps {
  event: AHCREvent
  onViewDetails: (event: AHCREvent) => void
  onImageClick: (url: string) => void
}

const AHCREventGridItem = ({ event, onViewDetails, onImageClick }: AHCREventGridItemProps) => {
  const date = new Date(event.createdDate)
  const genderInfo = getGenderInfo(event.gender)

  return (
    <div className='col-12 sm:col-6 lg:col-4 xl:col-3'>
      <Card className='event-card'>
        <div className='event-card-header'>
          {event.gender ? (
            <Tag value={genderInfo.label} severity={genderInfo.severity} icon={`pi ${genderInfo.icon}`} />
          ) : (
            <Tag value='Humano' severity='secondary' icon='pi pi-user' />
          )}
          <Tag
            value={date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
            icon='pi pi-clock'
            className='event-time-tag'
          />
        </div>

        <div
          className='event-card-image'
          onClick={() => event.detectionImageUrl && onImageClick(event.detectionImageUrl)}
        >
          {event.detectionImageUrl ? (
            <div className='event-image-wrapper'>
              <img src={event.detectionImageUrl} alt='Pessoa' className='event-main-image' />
              <div className='event-image-overlay'>
                <i className='pi pi-search-plus' />
              </div>
            </div>
          ) : (
            <div className='event-no-image'>
              <i className='pi pi-image' />
              <span>Sem imagem disponível</span>
            </div>
          )}
        </div>

        <div className='event-card-info'>
          <div className='event-info-row'>
            <span className='event-info-label'>
              <i className='pi pi-calendar' />
              Data
            </span>
            <span className='event-info-value'>{date.toLocaleDateString('pt-BR')}</span>
          </div>

          <div className='event-info-row'>
            <span className='event-info-label'>
              <i className='pi pi-video' />
              Câmera
            </span>
            <span className='event-info-value text-sm'>{event.cameraName}</span>
          </div>

          {event.trousersColor && (
            <div className='event-info-row'>
              <span className='event-info-label'>
                <i className='pi pi-palette' />
                Calça
              </span>
              <span className={`events-color-badge events-color-${event.trousersColor?.toLowerCase()}`}>
                {getColorInfo(event.trousersColor)}
              </span>
            </div>
          )}

          {event.jacketColor && (
            <div className='event-info-row'>
              <span className='event-info-label'>
                <i className='pi pi-palette' />
                Blusa
              </span>
              <span className={`events-color-badge events-color-${event.jacketColor?.toLowerCase()}`}>
                {getColorInfo(event.jacketColor)}
              </span>
            </div>
          )}

          {event.stayDuration !== null && (
            <div className='event-info-row'>
              <span
                className='event-info-label'
                style={isLoitering(event.stayDuration) ? { color: 'var(--red-500)' } : undefined}
              >
                <i className='pi pi-stopwatch' />
                Permanência
              </span>
              <span
                className='event-info-value'
                style={isLoitering(event.stayDuration) ? { color: 'var(--red-500)', fontWeight: '600' } : undefined}
              >
                {formatStayDuration(event.stayDuration)}
              </span>
            </div>
          )}
        </div>

        <div className='event-card-actions'>
          <Button
            icon='pi pi-eye'
            label='Detalhes'
            className='p-button-sm w-full details-button'
            onClick={() => onViewDetails(event)}
          />
        </div>
      </Card>
    </div>
  )
}

export default AHCREventGridItem
